<template lang="pug">
.alert(:class="type" role="alert")
  i.alert__icon(:class="icon" aria-hidden="true")
  .alert__content
    .alert__title {{ title }}
    .alert__subtitle(v-if="subtitle") {{ subtitle }}
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    title: String,
    subtitle: String,
    type: String,
  },
  setup(props) {
    const icons = {
      info: "uil uil-info-circle",
      success: "uil uil-check-circle",
      warning: "uil uil-exclamation-triangle",
    };

    const icon = computed(
      () => icons[props.type] || "uil uil-exclamation-octagon"
    );

    return { icon };
  },
};
</script>

<style lang="scss" scoped>
.alert {
  @apply flex;
  @apply items-start;
  @apply gap-3;
  @apply px-4;
  @apply py-3;
  @apply rounded-lg;
  @apply text-sm;
  @apply bg-red-50;
  @apply text-red-700;
  @apply border;
  @apply border-red-200;

  &__icon {
    @apply text-lg;
    @apply leading-5;
    @apply flex-shrink-0;
  }

  &__content {
    @apply min-w-0;
  }

  &__title {
    @apply text-sm;
    @apply font-semibold;
  }
  &__subtitle {
    @apply text-xs;
    @apply opacity-90;
    @apply mt-0.5;
  }
}

.info {
  @apply bg-gignetblue-100;
  @apply text-gignetblue-600;
  @apply border-gignetblue-200;
}

.success {
  @apply bg-gignetgreen-100;
  @apply text-gignetgreen-800;
  @apply border-gignetgreen-200;
}

.warning {
  @apply bg-yellow-50;
  @apply text-yellow-700;
  @apply border-yellow-200;
}
</style>
